/**
 * Activation warn-gate for fixed-horizon OPTION scorecards.
 *
 * Option scorecards generated under the `fixed_horizon` objective are scored on a fixed-horizon option
 * mark-to-market return, which ignores the strategy exit (stops/targets/partials) and real option
 * execution — an exploratory entry-edge proxy, not realized backtest performance. Activating one gates
 * live entries on an unvalidated proxy, so activation requires an explicit acknowledgment.
 *
 * Option scorecards under the `strategy_exit` objective are scored on realized strategy-exit returns —
 * the same objective a backtest produces — and stock scorecards have no option proxy, so neither warns.
 *
 * Shared so the backend gate (`scorecards.attach`, the MCP attach tool) and the frontend confirmation
 * dialog compute one message from the same scorecard row fields.
 *
 * @returns the warning to surface and require acknowledgment for, or `null` when activation needs none.
 */
export function fixedHorizonOptionScorecardActivationWarning(scorecard) {
    if (scorecard.targetMetric !== 'option' || scorecard.objectiveMode !== 'fixed_horizon') {
        return null;
    }
    return ('This option scorecard is scored on a fixed-horizon option mark-to-market return, which ignores the strategy exit ' +
        '(stops/targets/partials) and real option execution — it is an exploratory entry-edge proxy, not realized backtest ' +
        'performance. Activating it gates live entries on an unvalidated proxy. Prefer a strategy-exit (realized) scorecard, ' +
        'or acknowledge the proxy to activate anyway.');
}
//# sourceMappingURL=fixedHorizonOptionScorecardActivationWarning.js.map